import useTranslation from 'next-translate/useTranslation';

// Lib
import { reportTypesOptions } from '@/lib/reports/tableConfigs/tableFilters';

// Components
import Select from '@/components/base/Select';

// Types
import type {
    RequestParamsType,
    SetRequestParamsType
} from '@/utils/hooks/swr/reports/useFetchReports';

import type { ReportTypeOptionType } from '@/lib/reports/tableConfigs/tableFilters';

type SelectReportTypeFilterProps = {
    reportType: 'history' | 'frequency';
    requestParams: RequestParamsType;
    setRequestParams: SetRequestParamsType;
};

const SelectReportTypeFilter = ({
    reportType,
    requestParams,
    setRequestParams
}: SelectReportTypeFilterProps) => {
    const { t } = useTranslation();
    const options =
        reportType === 'history'
            ? reportTypesOptions(t)?.filter((item) => item?.type !== 'frequency')
            : reportTypesOptions(t);
    const selectedOptionValue = requestParams?.filter_report ?? undefined;

    return (
        <Select
            buttonBaseStyle="noBorder"
            forcedDisplay
            className="w-full @2xl:w-44"
            setSelected={(option: Omit<ReportTypeOptionType, 'type'>) =>
                setRequestParams((prevState) => ({
                    ...prevState,
                    page: 1,
                    filter_report: option?.value ? option?.value : undefined
                }))
            }
            selected={options?.filter((item) => item?.value === selectedOptionValue)?.[0]}
            options={options}
            data-testid="select-report-type-filter"
        />
    );
};

export default SelectReportTypeFilter;
